import type {
  IProfileInfoStepAppearance,
  IProfileInfoStepResult,
} from '@/components/payments/profileInfo/config';
import { sendGAEvent } from '../utils';

export enum WithdrawEventsEnum {
  WITHDRAW_PROFILE_INFO_STEP_APPEARANCE = 'withdraw_profile_info_step_appearance',
  WITHDRAW_PROFILE_INFO_STEP_RESULT = 'withdraw_profile_info_step_result',
}

export const sendWithdrawProfileInfoStepAppearanceEvent = (
  data: IProfileInfoStepAppearance
) => {
  sendGAEvent(WithdrawEventsEnum.WITHDRAW_PROFILE_INFO_STEP_APPEARANCE, {
    event_category: 'withdraw',
    ...data,
  });
};

export const sendWithdrawProfileInfoStepResultEvent = (
  data: IProfileInfoStepResult
) => {
  sendGAEvent(WithdrawEventsEnum.WITHDRAW_PROFILE_INFO_STEP_RESULT, {
    event_category: 'withdraw',
    ...data,
  });
};
